export const HELPER_DEFAULT_URL = 'https://help.terra360.ru'

export const CONTACT_EMAIL = 'support@terra360.ru'
